import { formatCurrency } from "@/utils/format-currency";
import { formatLabel } from "@/utils/format-label";
import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";

export const PayoutColumns = [
  {
    accessorKey: "reference",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Reference</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.reference ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "destinationAccountName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Destination</div>,
    cell: ({ row }) => (
      <div>
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {row.original.destinationAccountName ?? "N/A"}
        </div>
        <div style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 2 }}>
          {row.original.destinationAccountNumber ?? "N/A"} ·{" "}
          {row.original.destinationBankName ?? "N/A"}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "amount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Amount</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatCurrency(row.original.amount) ?? "0"}
      </div>
    ),
  },
  {
    accessorKey: "fee",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Fee</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.fee || row.original.fee === 0
          ? formatCurrency(row.original.fee)
          : "-"}
      </div>
    ),
  },
  {
    accessorKey: "payoutType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatLabel(row.original.payoutType) ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "outBoxStatus",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const status = row.original.outBoxStatus;

      const getStatusColor = () => {
        switch (status) {
          case "SUCCESS":
            return { bg: "#ecfdf5", color: "#065f46" };
          case "FAILED":
            return { bg: "#fef2f2", color: "#991b1b" };
          case "REVERSED":
            return { bg: "#f3f4f6", color: "#374151" };
          case "PENDING":
          default:
            return { bg: "#fffbeb", color: "#92400e" };
        }
      };

      const { bg, color } = getStatusColor();

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {formatLabel(status) ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;

      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      const parsed = parseISO(date);

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },
];
